import { __ } from '@wordpress/i18n';
import { useState, useEffect } from 'react';

import { tabController } from '../../Components/utils/functions';

import Settings from './settings';
import Style from './Style';
import Feeds from './Feeds';
import Loading from './Components/Loading';
import useAllAccounts from './hooks/useAllAccounts';
import useBlockAccounts from './hooks/useBlockAccounts';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { cId } = attributes;

	useEffect(() => { (clientId && !cId) && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	useEffect(() => tabController(), [isSelected]);

	const [pageNumber, setPageNumber] = useState(1);

	const { allAccounts, loading } = useAllAccounts();
	const { accounts } = useBlockAccounts(allAccounts, attributes);

	if (loading) {
		return <Loading />
	}

	return <>

		<Settings attributes={attributes} setAttributes={setAttributes} clientId={clientId} setPageNumber={setPageNumber} />

		<div className={className} id={`ifbInstagramFeed-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			{accounts?.length ? <Feeds attributes={attributes} pageNumber={pageNumber} setPageNumber={setPageNumber} /> : <p className='ifbInsertAccess'>{__('Please Connect with Instagram Account', 'instagram-feed')}</p>}
		</div>
	</>;
};
export default Edit;